import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";

/** DEV-OCT-004: ONE server-computed next best action, identical on Home, /start, Labs and Academy.
 *  DEV-OCT-014: continue_impression fires only when the CTA is actually visible (IntersectionObserver),
 *  continue_clicked on click; both deduped per target per session. Starts/completions are server truth. */
const seen = (k) => { try { return sessionStorage.getItem(k) === "1"; } catch { return false; } };
const mark = (k) => { try { sessionStorage.setItem(k, "1"); } catch { /* ignore */ } };

export const ContinueCard = ({ compact = false }) => {
    const [nba, setNba] = useState(null);
    const ref = useRef(null);
    useEffect(() => {
        api.get("/me/next-best-action").then(({ data }) => setNba(data)).catch(() => {});
    }, []);
    useEffect(() => {
        if (!nba || !ref.current) return;
        const key = `nba_imp_${nba.target_id}`;
        if (seen(key)) return;
        const io = new IntersectionObserver((entries) => {
            if (entries.some((e) => e.isIntersecting && e.intersectionRatio >= 0.5)) {
                mark(key);
                api.post("/analytics/event", { event_type: "continue_impression", target_type: nba.target_type, target_id: nba.target_id, source_surface: window.location.pathname }).catch(() => {});
                io.disconnect();
            }
        }, { threshold: 0.5 });
        io.observe(ref.current);
        return () => io.disconnect();
    }, [nba]);
    if (!nba) return null;
    const onClick = () => {
        const key = `nba_clk_${nba.target_id}`;
        if (seen(key)) return;
        mark(key);
        api.post("/analytics/event", { event_type: "continue_clicked", target_type: nba.target_type, target_id: nba.target_id, source_surface: window.location.pathname }).catch(() => {});
    };
    const isFirst = nba.type === "first_flag";
    const tone = isFirst ? "emerald" : "cyan";
    return (
        <Link ref={ref} to={nba.target} onClick={onClick} data-testid="continue-hacking-card" data-nba-type={nba.type} data-nba-target={nba.target}
              className={`group flex items-center gap-3 border rounded-sm px-4 transition-colors min-h-[56px] ${compact ? "py-2.5" : "py-3"} ${tone === "emerald" ? "border-emerald-500/30 bg-emerald-500/[0.05] hover:border-emerald-400/60" : "border-cyan-500/30 bg-cyan-500/[0.05] hover:border-cyan-400/60"}`}>
            <div className="min-w-0 flex-1">
                <div className={`font-mono text-[9px] uppercase tracking-[0.25em] mb-0.5 ${tone === "emerald" ? "text-emerald-300/80" : "text-cyan-300/80"}`}>
                    // {isFirst ? "your first win" : "continue hacking"} · {nba.type.replace(/_/g, " ")}
                </div>
                <div className="text-sm font-bold text-slate-100 break-words line-clamp-2" style={{ fontFamily: "'Space Grotesk', 'Chivo', sans-serif" }}>{nba.title}</div>
                {!compact && <div className="text-[11px] text-slate-500 font-mono break-words line-clamp-2">{nba.reason}</div>}
            </div>
            <span className={`shrink-0 font-mono text-[10px] uppercase tracking-widest transition-colors ${tone === "emerald" ? "text-emerald-300 group-hover:text-emerald-200" : "text-cyan-300 group-hover:text-cyan-200"}`}>{isFirst ? "start →" : "go →"}</span>
        </Link>
    );
};
